import React, { FC, Fragment, useState } from 'react';
import { Button, Box, Grid, useMediaQuery, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FreeTextFilterComponent from 'components/users/shared/free-text-filter/free-text-filter.component';
import FilterOnStatusDropdown from 'components/users/shared/filter-on-status-dropdown/filter-on-status-dropdown.component';
import { ClinicDropdown, UserListFilter } from 'models/user';
import ClinicsAutocomplete from '../clinics-autocomplete/clinics-autocomplete.component';
import AddIcon from '@mui/icons-material/Add';

type AdminDentistPageActionsProps = {
    onFilterChange: ({ freeText, active }: UserListFilter) => void;
    onClinicChange: (clinic: string | null) => void;
    onAddDentistDialogOpen: () => void;
};
const AdminDentistPageActions: FC<AdminDentistPageActionsProps> = ({
    onFilterChange,
    onClinicChange,
    onAddDentistDialogOpen,
}: AdminDentistPageActionsProps) => {
    const { t: translate } = useTranslation(['users']);
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
    const [filter, setFilter] = useState<UserListFilter>({
        freeText: '',
        active: true,
    });

    const handleFilterChange = (freeTextInput: string) => {
        setFilter({
            freeText: freeTextInput,
            active: filter.active,
        });
        onFilterChange({
            freeText: freeTextInput,
            active: filter.active,
        });
    };

    const handleStatusSelected = (active: boolean | null) => {
        setFilter({
            freeText: filter.freeText,
            active: active,
        });
        onFilterChange({
            freeText: filter.freeText,
            active: active,
        });
    };

    const handleSelectedClinic = (clinic?: ClinicDropdown | null) => {
        if (clinic) {
            onClinicChange(clinic._id);
            return;
        }
        onClinicChange(null);
    };

    return (
        <Fragment>
            <Box mb={1} display="flex" alignItems="center" flexDirection={!isMobile ? 'row' : 'column-reverse'}>
                <Grid container spacing={1}>
                    <Grid item md={4} xs={12}>
                        <ClinicsAutocomplete fullWidth onParentClinicChange={handleSelectedClinic} />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <FreeTextFilterComponent
                            value={filter.freeText}
                            freeTextFilterChange={handleFilterChange}
                            label="Filter name"
                        />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <FilterOnStatusDropdown fullWidth statusSelected={handleStatusSelected} />
                    </Grid>
                </Grid>
                <Box flex="1 0 auto">
                    <Button variant="contained" size="medium" onClick={onAddDentistDialogOpen} startIcon={<AddIcon />}>
                        {translate('users:ADD_DENTIST')}
                    </Button>
                </Box>
            </Box>
        </Fragment>
    );
};

export default AdminDentistPageActions;
